import * as React from 'react';

import AdminSyncTypeClasslinkPickerView from 'admin/rostering/components/AdminSyncTypeClasslinkPickerView';
import AdminSyncTypeCSVPickerView from 'admin/rostering/components/AdminSyncTypeCSVPickerView';
// @ts-ignore
import CurrentUser from 'auth/CurrentUser';
import { SyncType } from 'globalTypes';

type Props = {
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
  syncType: SyncType;
  displaySyncType: (syncType: SyncType) => void;
};

class AdminSyncTypeSpreadsheetView extends React.Component<Props> {
  handleHideRequest = () => {
    this.props.onClose();
  };

  handleContinue = (syncType: SyncType) => {
    this.props.selectSyncType(syncType);
    this.handleHideRequest();
  };

  render() {
    const { syncType, displaySyncType } = this.props;
    const currentUser = CurrentUser.getUser();
    const shouldRenderClasslink = currentUser.hasFeature('rostering_classlink_support.web.apr-21');

    return (
      <React.Fragment>
        {shouldRenderClasslink ? (
          <AdminSyncTypeClasslinkPickerView
            data-test={`sis-setup-classlink-picker-view-${SyncType.classlink}`}
            syncType={syncType}
            displaySyncType={displaySyncType}
            handleContinue={this.handleContinue}
          />
        ) : (
          <AdminSyncTypeCSVPickerView
            data-test={`sis-setup-csv-picker-view-${syncType}`}
            syncType={syncType}
            displaySyncType={displaySyncType}
            handleContinue={this.handleContinue}
          />
        )}
      </React.Fragment>
    );
  }
}

export default AdminSyncTypeSpreadsheetView;
